<span class="inline-moving-text-container" [class.animating]="isAnimating()">
  <span class="moving-word leading-tight pb-0 mb-0">
    {{ staticWord() }}
    <span [class]="movingWordClass()">
      {{ currentWord() }}
    </span>
  </span>
</span>
